<template>
  <div class="right-drawer">
    <div class="hide-on-med-and-down">
      <div
        v-if="showRightPanel && currentRouteName !== 'create-article'"
        class="card z-depth-0"
      >
        <!-- This p-tag below will in the future be replaced with the proper components like notifications for example.-->
        <p class="center">
          {{
            this.$store.state.user.langEng
              ? "More info pending.."
              : "Mer info kommer senare.."
          }}
        </p>
      </div>
      <component :is="currentRoute"></component>
    </div>

    <ul id="slide-out-right" class="sidenav sidenav-right">
      <div v-if="showRightPanel && currentRouteName !== 'create-article'">
        <!-- This p-tag below will in the future be replaced with the proper components like notifications for example.-->
        <p class="center">
          {{
            this.$store.state.user.langEng
              ? "More info pending.."
              : "Mer info kommer senare.."
          }}
        </p>
        <div class="divider"></div>
        <button class="btn black sidenav-close">
          {{ this.$store.state.user.langEng ? "Close" : "Stäng" }}
        </button>
      </div>
      <component :is="currentRoute"></component>
      <div class="divider"></div>
      <button class="btn black sidenav-close">
        {{ this.$store.state.user.langEng ? "Close" : "Stäng" }}
      </button>
    </ul>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import CreateArticlePanel from "./CreateArticlePanel";

@Component()
export default class RightPanel extends Vue {
  get showRightPanel() {
    return this.$store.state.drawers.showRightPanel;
  }

  get currentRouteName() {
    let path = this.$route.path.split("/")[1];
    return path;
  }

  get currentRoute() {
    let path = this.$route.path.split("/")[1];
    switch (path) {
      case "":
        return () => import("./Notifications");
      case "create-article":
        return CreateArticlePanel;
      default:
        return () => import("./Notifications");
    }
  }

  get isMobile() {
    return this.$store.state.isMobile;
  }

  toggleDrawer(val) {
    this.$store.commit("toggleRightDrawer", val);
  }

  mounted() {
    let elem = document.querySelector(".right-drawer .sidenav");
    this.$M.Sidenav.init(elem, { edge: "right" });
  }
}
</script>

<style scoped lang="scss">
.right-drawer {
  padding: 0 calc(0.75em + 15px) 0 0.75em;
  p {
    margin: 1em 0 0.5em;
  }
  .card {
    border-radius: 5px;
    margin: 1.5em 0 0;
    padding: 1em 1em 2em;
    position: relative;
    .divider {
      margin: 1em 0;
    }
  }
}
.sidenav {
  padding: 0 1em !important;
  .btn {
    margin: 1em 0 0;
    width: 80%;
    line-height: 0.8em;
  }
  p {
    margin: 1em 0 0.5em;
  }
}

@media (max-width: 992px) {
  .right-drawer {
    padding: 0 0.75em 0 0.75em !important;
    width: 0;
  }
}
</style>
